import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { IconNews, IconDoc, IconArrow, IconDownload } from "../components/Icons";
import { getNews, getPublications } from "../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CONFIG = {
  "insights-news": {
    testid: "insights-news-page",
    eyebrow: "Updates & insights",
    title: "Insights & News",
    lead: "Announcements, insights, and updates from Lemur Quality.",
    crumb: "Insights & News",
    icon: <IconNews />,
    heading: "No articles published yet",
    body: "We are preparing insights and updates on quality assurance, compliance, and best practice. Please check back soon.",
    fetch: getNews,
  },
  publications: {
    testid: "publications-page",
    eyebrow: "Publications & downloads",
    title: "Publications & Downloads",
    lead: "Downloadable materials and publications from Lemur Quality.",
    crumb: "Publications & Downloads",
    icon: <IconDoc />,
    heading: "Publications coming soon",
    body: "Publications and downloadable materials will be added here. Please check back soon.",
    fetch: getPublications,
  },
};

export default function ResourceModule({ type }) {
  const c = CONFIG[type];
  const [items, setItems] = useState([]);
  useEffect(() => { CONFIG[type].fetch().then(setItems).catch(() => setItems([])); }, [type]);

  return (
    <div data-testid={c.testid}>
      <Seo title={`${c.title} — Lemur Quality`} description={c.lead} />
      <PageHeader eyebrow={c.eyebrow} title={c.title} lead={c.lead} crumb={c.crumb} />
      <section className="section bg-paper">
        <div className="wrap">
          {items.length === 0 ? (
            <Reveal className="res-empty" data-testid="empty-state">
              <div className="re-ic">{c.icon}</div>
              <h3>{c.heading}</h3>
              <p>{c.body}</p>
              <Link to="/contact" className="btn btn-primary" data-testid="empty-contact-cta">Contact our team</Link>
            </Reveal>
          ) : type === "insights-news" ? (
            <div className="hub-grid" data-testid="news-list">
              {items.map((it, i) => (
                <Reveal key={it.id} delay={(i % 2) * 60}>
                  <Link to={`/resources/insights-news/${it.slug}`} className="hub-card" data-testid={`news-card-${it.slug}`}>
                    {it.cover_media_id && (
                      <img src={`${BACKEND_URL}/api/media/${it.cover_media_id}`} alt="" loading="lazy" style={{ width: "100%", height: 180, objectFit: "cover", borderRadius: 12, marginBottom: 16 }} />
                    )}
                    <span className="mono" style={{ fontSize: ".72rem", color: "var(--crimson)", marginBottom: 8 }}>{it.date}</span>
                    <h3>{it.title}</h3>
                    <p>{it.excerpt}</p>
                    <span className="more">Read article <IconArrow /></span>
                  </Link>
                </Reveal>
              ))}
            </div>
          ) : (
            <>
              <div className="hub-grid" data-testid="publications-list">
                {items.map((it, i) => (
                  <Reveal key={it.id} delay={(i % 2) * 60}>
                    <a href={`${BACKEND_URL}${it.url}`} target="_blank" rel="noopener noreferrer" className="hub-card" data-testid={`publication-${it.id}`}>
                      <div className="hc-ic"><IconDoc stroke="#e11d3c" /></div>
                      <h3>{it.title}</h3>
                      <p>{it.description}</p>
                      <span className="more"><IconDownload style={{ width: 15, height: 15 }} /> Download</span>
                    </a>
                  </Reveal>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
